import { Collapsible } from '@base-ui/react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import type { ReactNode } from 'react';
import { cx } from '@/cva.config';

export interface AccordionProps {
  chevronPosition?: 'left' | 'right';
  children: ReactNode;
  className?: string;
  defaultOpen?: boolean;
  panelClassName?: string;
  title: ReactNode;
  triggerClassName?: string;
}

export const Accordion = ({
  chevronPosition = 'left',
  children,
  className,
  defaultOpen = false,
  panelClassName,
  title,
  triggerClassName,
}: AccordionProps) => (
  <Collapsible.Root className={className} defaultOpen={defaultOpen}>
    <Collapsible.Trigger
      className={cx(
        'flex w-full items-center gap-2 rounded-md px-3 py-2 text-left text-sm lg:text-base font-medium transition-colors',
        'hover:bg-border/30 data-panel-open:bg-border/20',
        chevronPosition === 'right' && 'justify-between',
        triggerClassName,
      )}
    >
      {chevronPosition === 'left' && (
        <ChevronRight className="size-3.5 shrink-0 text-foreground-muted transition-transform duration-200 [[data-panel-open]>&]:rotate-90" />
      )}
      {title}
      {chevronPosition === 'right' && (
        <ChevronDown className="size-3.5 shrink-0 text-foreground-muted transition-transform duration-200 [[data-panel-open]>&]:rotate-180" />
      )}
    </Collapsible.Trigger>
    <Collapsible.Panel
      className={cx(
        'h-(--collapsible-panel-height) overflow-hidden transition-[height] duration-200 ease-out data-ending-style:h-0 data-starting-style:h-0',
        panelClassName,
      )}
    >
      {children}
    </Collapsible.Panel>
  </Collapsible.Root>
);
